/*
 * @Author: cyl
 * @Date: 2022-09-02 10:42:21
 * @LastEditors: cyl
 * @LastEditTime: 2022-09-06 10:01:44
 * @Description:
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import utils from "./util/index";
import IconSvg from "@/components/common/iconSvg";

// 解决路由重复点击的报错问题（路由版本问题）
import Router from "vue-router";
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

//vue-video-player插件--------------------------------------------
import VideoPlayer from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";
import "@/assets/css/videoPage/myVideoCss.css";

Vue.use(VideoPlayer);
//videojs热键插件--------------------------------------------
import videojshotkeys from "videojs-hotkeys";
Vue.use(videojshotkeys);

//事件总线
Vue.prototype.$bus = new Vue();

//elementUI组件--------------------------------------------
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// 注册工具
Vue.prototype.$util = utils;

//icon组件
Vue.component("icon-svg", IconSvg);

Vue.config.productionTip = false;

let vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default vue;
